module.exports = __webpack_public_path__ + "img/transfer.c6f784ac.svg";